import { Box, styled } from '@mui/material';

const DocContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isFullWidth' && prop !== 'isContentExpanded',
})<{
  isFullWidth: boolean;
  isContentExpanded: boolean;
}>(({ theme, isFullWidth, isContentExpanded }) => ({
  paddingTop: theme.spacing(2),
  paddingInline: theme.spacing(0),
  maxWidth: 'calc(100% - 48px)',
  width: '100%',
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    maxWidth: '100%',
  },
  [theme.breakpoints.up('md')]: {
    maxWidth: isFullWidth ? '100%' : '1127px',
    paddingRight: isContentExpanded ? theme.spacing(3) : theme.spacing(2),
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: isFullWidth ? '100%' : '983px',
    paddingRight: isContentExpanded ? theme.spacing(4) : theme.spacing(2),
  },
  [theme.breakpoints.up('xl')]: {
    maxWidth: isFullWidth ? '100%' : '977px',
    paddingRight: isContentExpanded ? theme.spacing(5) : theme.spacing(2),
  },
}));

export const pageStyle = `
@page {
  margin: 20mm;
}

body {
  background: white !important;
  color: black !important;
}

.dark-theme {
  background: white !important;
  color: black !important;
}

`;

export default DocContainer;
